import { createGlobalStyle } from 'styled-components';
import breakpoints from '@rsc/ui-components/breakpoints';
import { styles as sharedStyles } from '@rsc/ui-components/styles';

export const GlobalStyles = createGlobalStyle`
  html, body {
    background: ${({ theme }) => theme.colors.background};
  }

  *, *::before, *::after {
    box-sizing: inherit;
    line-height: inherit;
  }

  /* this is needed to make styled inputs work on Safari 🤷
  https://stackoverflow.com/questions/49889003/cannot-write-into-input-field-on-safari */
  input, input:before, input:after {
    -webkit-user-select: initial;
    -moz-user-select: initial;
    -ms-user-select: initial;
    user-select: initial;
  }

  a {
    &:hover {
      text-decoration: none;
    }
  }

  strong {
    font-style: inherit;
  }

  sup {
    top: revert;
    vertical-align: super;
    font-size: 75%;
  }

  ol {
    list-style-type: decimal;

    @media screen and (min-width: ${breakpoints.md}){
      margin-left: 0;
    }
  }

  ol li {
    margin-bottom: ${sharedStyles.spacing['spacing-md']};
  }

  input, select, textarea {
    background-color: white;
    font-family: inherit;
  }

  @media print {
    * {
      color: black !important;
    }
  }
`;

export default GlobalStyles;
